const initialState = {
    status_progress_bar: false,
};
const progressBar = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_PROGRESS_BAR':
            return {...state, status_progress_bar: action.payload.status_progress_bar};
        default:
            return state;
    }
};

export default progressBar;